import { RawRule } from '@casl/ability';
import { IMenu } from '../models/login';
import _ from 'lodash';

export function ConvertAbility(menus: IMenu[]): RawRule[] {
    const abilities = new Array<RawRule>();
    menus.forEach((m) => {
        _.forEach(m.pageOptions, (pageOption) => {
            if (pageOption.access && pageOption.access.toString() === 'true') {
                abilities.push({
                    subject: m.page_code,
                    action: pageOption.code,
                });
            }
        });
        _.forEach(m.subMenus, function (subMenu) {
            if (subMenu.pageOptions) {
                _.forEach(subMenu.pageOptions, function (pageOption) {
                    if (pageOption.access && pageOption.access.toString() === 'true') {
                        abilities.push({
                            subject: subMenu.page_code,
                            action: pageOption.code,
                        });
                    }
                });
            }
        });
    });
    return abilities;
}
